export default [
    {
        label: 'Username',
        key: 'username',
        required: false,
        displayOrder: 1,
    },
    {
        label: 'Password',
        key: 'password',
        required: true,
        type: 'password',
        displayOrder: 2,
    },
    {
        label: 'Email',
        key: 'email',
        required: true,
        type: 'email',
        displayOrder: 3,
    },
    {
        label: 'Phone Number',
        key: 'phone_number',
        required: true,
        displayOrder: 4,
    },
];
export var signUpWithEmailFields = [
    {
        label: 'Email',
        key: 'email',
        required: true,
        type: 'email',
        displayOrder: 1,
    },
    {
        label: 'Password',
        key: 'password',
        required: true,
        type: 'password',
        displayOrder: 2,
    },
    {
        label: 'Phone Number',
        key: 'phone_number',
        required: true,
        displayOrder: 3,
    },
];
export var signUpWithPhoneNumberFields = [
    {
        label: 'Phone Number',
        key: 'phone_number',
        required: true,
        displayOrder: 1,
    },
    {
        label: 'Password',
        key: 'password',
        required: true,
        type: 'password',
        displayOrder: 2,
    },
    {
        label: 'Email',
        key: 'email',
        required: true,
        type: 'email',
        displayOrder: 3,
    },
];
//# sourceMappingURL=default-sign-up-fields.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-amplify-angular/dist/src/assets/default-sign-up-fields.js
// module id = null
// module chunks = 